import gql from 'graphql-tag';

const GET_VIEWS = gql`
  query getViews($modules: [ID!]) {
    getViews(modules: $modules) {
      module
      views {
        id
        name
        module
        displayIcon
        viewCondition
        customView
        shared
        systemViewProperty
        viewSubType
      }
    }
  }
`;

const GET_VIEW = gql`
  query($viewId: ID!, $module: String!) {
    getView(module: $module, viewId: $viewId) {
      id
      name
      displayIcon
      viewCondition
      shared
      viewSubType
    }
  }
`;

export { GET_VIEWS, GET_VIEW };
